import { onAddProductCatalog } from "../../utils/ProductCatalog";

export const createProductCatalogNode = ({ dispatch, nodes, nodeId }) => {
  const currNode = nodes.find((node) => node.id === nodeId);
  const type = currNode?.type;

  const axis = {
    x: currNode.position.x + 200,
    y: currNode.position.y,
  };

  if (type === "user") {
    axis.y = axis.y + 10;
  }

  onAddProductCatalog(dispatch, axis, nodeId);
};
